"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TouchOfTheDeadAbilityHandler = exports.TouchOfTheDeadActorAbilityFactory = exports.TouchOfTheDeadAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Damage_1 = require("../../core/Damage");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class TouchOfTheDeadAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.TouchOfTheDead;
        this.__typeName = "TouchOfTheDead";
    }
}
exports.TouchOfTheDeadAbilityArgs = TouchOfTheDeadAbilityArgs;
let TouchOfTheDeadActorAbilityFactory = class TouchOfTheDeadActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("TouchOfTheDead", "OneEnemies", 0);
    }
};
TouchOfTheDeadActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("TouchOfTheDead")
], TouchOfTheDeadActorAbilityFactory);
exports.TouchOfTheDeadActorAbilityFactory = TouchOfTheDeadActorAbilityFactory;
let TouchOfTheDeadAbilityHandler = class TouchOfTheDeadAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Death", 50),
                AbilityDamage_1.AbilityDamage.Focus("Frost", 50),
            ],
            onHit(sequence, _, damages) {
                const totalDamage = Damage_1.Damage.Sum(damages);
                container.applyHealing({
                    healerId: ability.invokerId,
                    targetId: container.getActor(ability.invokerId).ownerId,
                    amount: Math.round(.5 * totalDamage),
                    attributePercent: 0,
                    sequence
                });
            }
        });
    }
};
TouchOfTheDeadAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.TouchOfTheDead)
], TouchOfTheDeadAbilityHandler);
exports.TouchOfTheDeadAbilityHandler = TouchOfTheDeadAbilityHandler;
